import { configureStore } from '@reduxjs/toolkit'
import authenticationReducer from "./features/auth/authenticationSlice"

export default configureStore({
    reducer: {
        authentication: authenticationReducer,
    }
});
